import { httpClient } from "../../Api";
import { useAuth } from "../../../authentication";
import { postApi, putApi, getApi } from "../../Axios";

export const useServiceSubGroup = () => {
  const { getLogout } = useAuth();

  const addServiceSubGroup = (serviceSubGroup, callbackFun) => {
    postApi(
      `Administration/ServicesSubGroup`,
      serviceSubGroup,
      callbackFun,
      "msg",
      getLogout,
      true
    );
  };

  const getServiceSubGroupById = (id, callbackFun) => {
    getApi(
      `Administration/ServicesSubGroup/${id}`,
      callbackFun,
      "data",
      getLogout,
      true
    );
  };

  const updateServiceSubGroup = (model, callbackFun) => {
    const { serviceSubGroupID } = model;
    putApi(
      `Administration/ServicesSubGroup/${serviceSubGroupID}`,
      model,
      callbackFun,
      "msg",
      getLogout,
      true
    );
  };

  return {
    addServiceSubGroup,
    getServiceSubGroupById,
    updateServiceSubGroup,
  };
};
